import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import Glass from "../Glass";

import * as S from "./CSLoading.Style";

const svgFrames = [
  `<svg width="80" height="80" viewBox="0 0 286 287" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M142.377 77.2131H81.8934L42 0H142.377H143.664H244.041L204.148 77.2131H143.664H142.377Z" fill="#003672"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M142.377 209H81.8934L42 286.213H142.377H143.664H244.041L204.148 209H143.664H142.377Z" fill="#A3C5EB"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M245.27 4L285.54 81.25H284.77V204.75H285.54L245.27 282L205 204.75H205.77V81.25H205L245.27 4Z" fill="#A3C5EB"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M40.2702 4L80.5404 81.25H79.7702V204.75H80.5404L40.2702 282L0 204.75H0.77018V81.25H0L40.2702 4Z" fill="#A3C5EB"/>
  </svg>`,
  `<svg width="80" height="80" viewBox="0 0 286 287" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M142.377 77.2131H81.8934L42 0H142.377H143.664H244.041L204.148 77.2131H143.664H142.377Z" fill="#A3C5EB"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M142.377 209H81.8934L42 286.213H142.377H143.664H244.041L204.148 209H143.664H142.377Z" fill="#A3C5EB"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M245.27 4L285.54 81.25H284.77V204.75H285.54L245.27 282L205 204.75H205.77V81.25H205L245.27 4Z" fill="#005FC8"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M40.2702 4L80.5404 81.25H79.7702V204.75H80.5404L40.2702 282L0 204.75H0.77018V81.25H0L40.2702 4Z" fill="#A3C5EB"/>
  </svg>`,
  `<svg width="80" height="80" viewBox="0 0 286 287" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M142.377 77.2131H81.8934L42 0H142.377H143.664H244.041L204.148 77.2131H143.664H142.377Z" fill="#A3C5EB"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M142.377 209H81.8934L42 286.213H142.377H143.664H244.041L204.148 209H143.664H142.377Z" fill="#003672"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M245.27 4L285.54 81.25H284.77V204.75H285.54L245.27 282L205 204.75H205.77V81.25H205L245.27 4Z" fill="#A3C5EB"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M40.2702 4L80.5404 81.25H79.7702V204.75H80.5404L40.2702 282L0 204.75H0.77018V81.25H0L40.2702 4Z" fill="#A3C5EB"/>
  </svg>`,
  `<svg width="80" height="80" viewBox="0 0 286 287" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M142.377 77.2131H81.8934L42 0H142.377H143.664H244.041L204.148 77.2131H143.664H142.377Z" fill="#A3C5EB"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M142.377 209H81.8934L42 286.213H142.377H143.664H244.041L204.148 209H143.664H142.377Z" fill="#A3C5EB"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M245.27 4L285.54 81.25H284.77V204.75H285.54L245.27 282L205 204.75H205.77V81.25H205L245.27 4Z" fill="#A3C5EB"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M40.2702 4L80.5404 81.25H79.7702V204.75H80.5404L40.2702 282L0 204.75H0.77018V81.25H0L40.2702 4Z" fill="#005FC8"/>
  </svg>`,
];

const Loading = ({ center, alone }) => {
  const [currentFrame, setCurrentFrame] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentFrame((prev) => (prev + 1) % svgFrames.length);
    }, 200);

    return () => clearInterval(interval);
  }, []);

  return (
    <S.Container center={center} alone={alone}>
      <div
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: svgFrames[currentFrame] }}
      />
    </S.Container>
  );
};

const CSLoading = ({ className, size, center, alone, showGlass }) => {
  return showGlass ? (
    <Glass show>
      <Loading
        size={size}
        center={center}
        alone={alone}
        className={className}
      />
    </Glass>
  ) : (
    <Loading size={size} center={center} alone={alone} className={className} />
  );
};

CSLoading.propTypes = {
  className: PropTypes.string,
  showGlass: PropTypes.bool,
};

CSLoading.defaultProps = {
  className: "",
  showGlass: true,
};

export default CSLoading;
